import app from './app';

const i18n = {
  detect: () => {
    // add localStorage
    if (navigator.language === 'en' || navigator.language.match(/^en\-(.+)/)) {
      app.run.i18n = 'en';
    } else {
      app.run.i18n = 'en';
    }
  },

  render: () => {
    //document.title = app.run.settings.siteTitle;

    /*
    const title = `${app.run.settings.view[app.route].pageTitle}${app.run.settings.siteTitleSeparator}${app.run.settings.siteTitle}`;
    document.title = title;
    */

    let attribute = '';

    attribute = 'data-i18n';
    Array.from(document.querySelectorAll(`[${attribute}]`)).forEach((element) => {
      const attributeArray = element.getAttribute(attribute).split('-');
      element.innerHTML = app.run.settings[attributeArray[0]][attributeArray[1]][attributeArray[2]];
    });

    attribute = 'data-i18n-placeholder';
    Array.from(document.querySelectorAll(`[${attribute}]`)).forEach((element) => {
      const attributeArray = element.getAttribute(attribute).split('-');
      element.setAttribute('placeholder', app.run.settings[attributeArray[0]][attributeArray[1]][attributeArray[2]]);
    });
  },
};

export default i18n;
